const Projects = [
    {
        imgUrl:"https://github.com/mengyue-z/Sprinter-React/raw/main/screenshots/dashboard.png",
        title:"Sprinter 2.0",
        description:"A project and employee management application built in React with a Mongo database.",
        repo:"https://github.com/mengyue-z/Sprinter-React",
        live:"https://vibrant-pasteur-087033.netlify.app/",
        techUsed: "HTML/CSS, Javascript, MongoDB, Express, React, Node.js, Bootstrap"
    },
    {
        imgUrl:"https://github.com/mengyue-z/Project_Management_App/raw/main/screenshots/employee.png",
        title:"Sprinter",
        description:"Sprinter is an application for tracking and managing developer sprints.It is designed with you and your development sprints in mind. Use the app to add sprints, add employees and managers to sprints, and keep track of your progress and division of labor as your project progresses.",
        repo:"https://github.com/mengyue-z/Project_Management_App",
        live :"https://fast-everglades-95030.herokuapp.com/",
        techUsed: "HTML/CSS, Javascript, MySQL, CRUD"
    },
    { 
        imgUrl:"https://github.com/mengyue-z/Google-Books-Search/raw/main/client/public/images/screenshot1.png",
        title:"Google Book Search",
        description:"This is a React-based Google Books Search app. Users can search books with Google Books API and save them for future reference.",
        repo:"https://github.com/mengyue-z/Google-Books-Search",
        live:"https://salty-headland-20840.herokuapp.com/",
        techUsed: "HTML/CSS, Javascript, MongoDB, Express, React, Node.js"
    },
    { 
        imgUrl:"https://github.com/mengyue-z/Online-Offline-Budget-Trackers/raw/main/public/images/screenshot1.png",
        title:"Budget Tracker",
        description:"This is a budget tracker application that users will be able to add expenses and deposits to their budget with or without a connection When entering transactions offline, the total will be populated when the application is back online.",
        repo:"https://github.com/mengyue-z/Online-Offline-Budget-Trackers",
        live:"https://sleepy-depths-24870.herokuapp.com/",
        techUsed: "HTML/CSS, Javascript, Mongoose, Express, Node.js, Heroku, IndexedDb"
    },
    {
        imgUrl:"https://github.com/mengyue-z/Wellness-Place-Finder/raw/main/assets/website-2.png",
        title:"Wellness Place Finder",
        description:"Wellness website that will search API's to find closest exercise classes and calculate their Body Mass Index (BMI).",
        repo:"https://github.com/mengyue-z/Wellness-Place-Finder",
        live :"https://mengyue-z.github.io/Wellness-Place-Finder",
        techUsed: "HTML/CSS, Javascript, Bootstrap, JQuery, API"
    },
    {
        imgUrl:"https://github.com/mengyue-z/Employee-Directory/raw/main/public/images/screenshot1.png",
        title:"Employee-Directory",
        description:"This is a employee directory application with React where users can view all the informations of the employees and are able to sort or filter the results.",
        repo:"https://github.com/mengyue-z/Employee-Directory/",
        live :"https://mengyue-z.github.io/Employee-Directory",
        techUsed: "HTML/CSS, Javascript, React, API"
    },
    {
        imgUrl:"https://github.com/mengyue-z/weather-dashboard/raw/main/screenshots/img2.jpg",
        title:"Weather Dashboard",
        description:"This is an application that users can get weather information for different cities all over the world.Once users search for a city, the current weather and 5-day forecast will be displayed.",
    live:"https://mengyue-z.github.io/weather-dashboard/",
    repo:"https://github.com/mengyue-z/weather-dashboard",
    techUsed: "HTML/CSS, Javascript, API"
    },
    {
        imgUrl:"https://github.com/mengyue-z/Workout-Tracker/raw/main/public/images/screenshot3.png",
        title:"Workout Tracker",
        description:"This is a workout tracker application where users can create workouts, record exercises they have done in that workout session and visualize the workout records for the last 7 days with charts.",
        repo:"https://github.com/mengyue-z/Workout-Tracker",
        live :"https://thawing-lowlands-15735.herokuapp.com/",
        techUsed: "HTML/CSS, Javascript, Express, Node.js, Mongoose"
    },
    {
        imgUrl:"https://github.com/mengyue-z/Note-Taker/raw/main/public/assets/screenshot.jpg",
        title:"Note Taker",
        description:"This is a note-taking application powered by Express.js that users can write and save notes on the page and retrieve notes any time they want.",
        repo:"https://github.com/mengyue-z/Note-Taker",
        live:"https://vast-basin-31119.herokuapp.com/",
        techUsed: "HTML/CSS, Javascript, Express, Node.js"
    }
]
  export default Projects ;